import { DeleteButton, EditButton, WrapperField } from "react-admin";
import { MyList } from "../../components/MyList";
import { MyField } from "../../components/types";
import { Field } from "../../utils/Field";
import React from "react";
import MyCreate from "../../components/MyCreate";
import MyEdit from "../../components/MyEdit";
import PermDataSettingIcon from "@mui/icons-material/PermDataSetting";

const fields: MyField[] = [
  Field.editNumber({
    label: "时间(分钟)",
    source: "id",
    isCreate: true,
    isUpdate: false,
    isEdit: false,
  }),
  Field.editNumber({
    label: "费率(10 == 10%)",
    source: "rate",
    isFilter: false,
    minWidth: 200,
  }),
  Field.dateTime({
    label: "创建时间",
    source: "createdDate",
  }),
  Field.dateTime({
    label: "更新时间",
    source: "updateDate",
  }),
];

const resource = {
  list: () => {
    return (
      <MyList
        pagination={false}
        fields={fields}
        rowActions={[<EditButton />, <DeleteButton />]}
        tableActions={
          <WrapperField>
            <EditButton />
            <DeleteButton />
          </WrapperField>
        }
        // groupingColDef={groupingColDef}
      />
    );
  },
  create: () => {
    return <MyCreate fields={fields} />;
  },
  edit: () => {
    return <MyEdit fields={fields} />;
  },
  icon: PermDataSettingIcon,
};

export default resource;
